import { useAnalyticLinkLocation, useAnalyticSession } from "@octopusdeploy/portal-analytics";
import { usePageInstanceSummary } from "../page/PageInstanceSummaryProvider";
import type { PageFields } from "./PageEventDispatcher";
import { getPageFields } from "./PageEventDispatcher";
export interface LinkEvent {
    linkLabel: string;
    documentUrl: string | undefined;
    linkLocation?: string;
}
export interface LinkFields extends PageFields {
    "Document URL"?: string;
    "Link Label": string;
    "Link Location": string;
    "Page Area": string;
    "Page Id": string;
}
export type AnalyticsLinkClickedDispatcher = (name: string, event: LinkEvent) => void;
export function useDispatchLinkClicked(): AnalyticsLinkClickedDispatcher {
    const session = useAnalyticSession();
    const contextLinkLocation = useAnalyticLinkLocation();
    const page = usePageInstanceSummary();
    return (name: string, event: LinkEvent) => {
        if (!page) {
            return;
        }
        const fields: LinkFields = {
            "Link Label": event.linkLabel,
            "Link Location": event.linkLocation ?? contextLinkLocation ?? "",
            ...getPageFields(page),
        };
        if (event.documentUrl) {
            fields["Document URL"] = event.documentUrl;
        }
        session.track(name, fields);
    };
}
export function nameForLink() {
    return `Navigate to Page`;
}
